"use client";
import { Program } from "@/components/newIcons/Program";
import type { Countries } from "@/queries/getCountries";
import { SecondaryButton } from "ui/components";
import type { Departure } from "../../getDeparture";
import type { Travel } from "../../getTravel";
import { RequestProgram } from "../RequestProgram";
import { requestProgrammeOnSuccessServer } from "../RequestProgram/requestProgrammeOnSuccessServer";

type Props = {
  travel: Travel;
  departure: Departure;
  countries: Countries;
};
export const BottomRequestProgram = ({ travel, departure, countries }: Props) => {
  return (
    <RequestProgram
      travelId={travel.id}
      isAvailable={departure.state.versionStatus !== "soon"}
      versionId={departure.versionId}
      departureId={departure.id}
      onSuccess={() => requestProgrammeOnSuccessServer(travel, departure)}
      countries={countries}
      travelTitle={travel.title}
      travelImage={travel.travelImages[0] || null}
      departure={departure}
      travelCountries={travel.countries}
      source="after_program"
    >
      <SecondaryButton className="mt-5 max-lg:w-full">
        <Program className="w-4 h-4" />
        Télécharger l'itinéraire complet
      </SecondaryButton>
    </RequestProgram>
  );
};
